import { render, staticRenderFns } from "./NotificationAnnouncement.vue?vue&type=template&id=b5e95e84&scoped=true&"
import script from "./NotificationAnnouncement.vue?vue&type=script&lang=js&"
export * from "./NotificationAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./NotificationAnnouncement.vue?vue&type=style&index=0&id=b5e95e84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e95e84",
  null
  
)

export default component.exports